import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './PrivacyPolicyPage.module.css';

const TERMLY_TERMS_ID = '6b3a1de6-f6b7-47f5-94e5-537cc373c22c';

const TermsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (document.getElementById('termly-jssdk')) return;

    const script = document.createElement('script');
    script.id = 'termly-jssdk';
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className={styles.container}>
      {/* Navigation */}
      <nav className={styles.nav}>
        <div className={styles.navContent}>
          <Link to="/" className={styles.logo}>
            <img src="/icons/autochef_logo.svg" alt="AutoChef" />
            <span>AutoChef</span>
          </Link>
          <div className={styles.navButtons}>
            <Link to="/signup" className={styles.navButton}>Start Free Trial</Link>
            <Link to="/login" className={styles.navButtonOutline}>Login</Link>
          </div>
        </div>
      </nav>

      {/* Terms - Termly Pro embed */}
      <main className={styles.main}>
        <div className={styles.policyContainer}>
          <div
            name="termly-embed"
            data-id={TERMLY_TERMS_ID}
          />
        </div>
      </main>

      {/* Footer */}
      <footer className={styles.footer}>
        <div className={styles.footerContent}>
          <div className={styles.footerBrand}>
            <img src="/icons/autochef_logo.svg" alt="AutoChef" />
            <span>AutoChef</span>
          </div>
          <div className={styles.footerLinks}>
            <Link to="/">Home</Link>
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
          <div className={styles.footerCopy}>
            © {new Date().getFullYear()} AutoChef. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsPage;
